import { Reducer as routerReducer } from 'modules/router';

import { STEP_CHECK_STATUS } from './router.constants';

const routerInitialState: routerReducer.IState = {
    currentView: STEP_CHECK_STATUS,
};

export default routerReducer.routerHOF(routerInitialState);
